

import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, HttpService } from 'ngx-block-core';
import { PageService, FormControlService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { selectSize, selectMode } from "../../../data/data";
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-sucu04-weiget0020004',
  templateUrl: './sucu04-weiget0020004.component.html',
  styleUrls: ['./sucu04-weiget0020004.component.css']
})
export class Sucu04Weiget0020004Component implements OnInit {
  workflow_id = ""
  cySysWorkflowRuntimeTablePrimaryValue = "";
  workflow_runId = "";
  workflow_flowpointCurrentId = "";
  workflow_flowpointCurrentName = "";



  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  @Input() sets = {
    blockCode: "sucublock50",
    blockId: "",
    blockName: "工作流积木1",
    layoutId: "",
    blockType: "formBlock",
    blockChildType: 'workflow',
    pageId: '',
    versionCode: 11,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    styles: {
      nzText: "工作流: ",
      nzSize: "default",
      nzPlaceHolder: "请输入内容",
      nzDefaultText: "无节点迁移: ",
      nzMinWidth: 100,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzHidden: false,
      nzAllowClear: true,
      nzShowSearch: true,
      nzMode: 'default',//radio
      nzMaxMultipleCount: 100,
      nzRequired: false,
      nzHasFeedback: false,
      nzExpandId: "",
    },
    datas: {
      nzDataSource: "",
      nzData: [],
      nzWorkflow: {
        nzSelectInit: true,
        nzWorkflowIdVirtualValue: "",
        nzCsysPotPublicId: [],
        csysPotStyleList: [],
        workflow_runId: {
          key: "",
          value: "",
        },
        nzCurrentTransferId: {
          key: "",
          value: "",
        },
        nzCurrentTransferName: {
          key: "",
          value: "",
        },
        nzPrimaryValue: {
          key: "",
          value: "",
        }
      },
      nzLinkage: {
        nzUsed: false,
        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzDynamicSql: ""
      }
    }
  };
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              {
                name: 'nzDataSource',
                inputs: {
                  nzType: "all",
                  nzMode: "default"
                }
              },
              {
                name: 'nzWorkflowRuntime',
              },
              { name: 'nzLinkage', inputs: { otherSets: ['sql'], nzBlockSets: this.sets } },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'input',
                inputs: { nzText: "默认信息 : ", nzKeys: ['styles', 'nzDefaultText'] }
              },

              // {
              //   name: 'input',
              //   inputs: { nzText: "标签名称 : ", nzKeys: ['nzText'] }
              // },

              { name: 'nzLayout', inputs: { nzType: '选择框', nzShow: true } },
              {
                name: 'select',
                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: [{ value: 'default', label: '下拉' }, { value: 'radio', label: '单选' }] }
              },
              {
                name: 'switch',
                inputs: { nzText: "隐藏 : ", nzKeys: ['styles', 'nzHidden'] }
              },
            ]
          }
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }

    ]
  }
  setData = []

  constructor(
    public setService: SetService,
    private http: HttpService,
    public pageService: PageService,
    private activatedRoute: ActivatedRoute,
    private jwtService: JwtService,
    private formControlService: FormControlService

  ) { }

  ngOnInit() {
    this.baseInit();
    this.autoUpdate();
    if (this.sets.datas.nzWorkflow.nzSelectInit !== false) {
      console.log('查询nzSelectInit')
      this.getWorkflowValue();
    } else {
      console.log('不查询nzSelectInit')
      this.getWorkflowValue(false, false);

    }
  }
  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {
      this.sets.blockType = "formBlock"
      this.sets.versionCode = 3;

    }

    //v4,升级自定义表单参数
    if (this.sets.versionCode < 4) {

      this.sets.blockCode = "sucublock50";

      this.sets.versionCode = 4;
    }
    //vc:5
    //联动
    if (this.sets.versionCode < 5) {
      if (typeof this.sets.datas.nzLinkage == "undefined") {
        this.sets.datas['nzLinkage'] = {
          nzUsed: true,
          nzEvents: [

          ],
        };
        this.sets.datas['nzLinkageData'] = {
          nzDynamicSql: ""
        }
      }
      this.sets.versionCode = 5;
    }
    //vc:6
    //影藏控件
    if (this.sets.versionCode < 6) {
      if (typeof this.sets.styles.nzHidden == "undefined") {
        this.sets.styles.nzHidden = false;
      }
      this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {
      this.sets.styles['nzDefaultText'] = "无节点迁移"
      this.sets.versionCode = 7;
    }
    if (this.sets.versionCode < 8) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 8;
    }

    if (this.sets.versionCode < 9) {

      this.sets.datas.nzWorkflow['nzCsysPotPublicId'] = []
      this.sets.versionCode = 9;
    }
    if (this.sets.versionCode < 10) {

      this.sets.datas.nzWorkflow['csysPotStyleList'] = []
      this.sets.versionCode = 10;
    }
    if (this.sets.versionCode < 11) {

      this.sets.datas.nzWorkflow['nzSelectInit'] = true;
      this.sets.versionCode = 11;
    }

  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "string|array";
        this.nzFormGroupData['nzSearchType'] = "=";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
        this.sets['pageId'] = this.setService.pageId;

      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;

      }

    }
    this.path = this.pageService.getPathByRoute(this.activatedRoute);
    this.Listening();
  }
  path
  queryParams
  getWorkflowValue(isHasParam?: boolean, nzSelectInit?: boolean) {

    if (!this.static) {
      if (isHasParam) {
        console.log("有参数")
      } else {
        this.workflow_id = this.sets.datas.nzWorkflow.nzWorkflowIdVirtualValue;
        this.cySysWorkflowRuntimeTablePrimaryValue = this.sets.datas.nzWorkflow.nzPrimaryValue.value;
        this.workflow_flowpointCurrentId = this.sets.datas.nzWorkflow.nzCurrentTransferId.value;
        this.workflow_flowpointCurrentName = this.sets.datas.nzWorkflow.nzCurrentTransferName.value;
        this.workflow_runId = this.sets.datas.nzWorkflow.workflow_runId.value;
      }



    } else {

      if (isHasParam) {
        console.log("有参数")
      } else {
        //获取场景值
        this.queryParams = this.pageService.getQueryParams(this.activatedRoute, this.path);

        this.workflow_id = this.queryParams['workflow_id'];
        this.workflow_flowpointCurrentName = this.queryParams['workflow_flowpointCurrentName'];
        this.workflow_flowpointCurrentId = this.queryParams['workflow_flowpointCurrentId'];
        this.workflow_runId = this.queryParams['workflow_runId'];
        this.cySysWorkflowRuntimeTablePrimaryValue = this.queryParams[this.sets.datas.nzWorkflow.nzPrimaryValue.key];

        console.log("没有参数")
      }

    }

    this.pageService.pageBlockDatas[this.blockid] = {
      workflow: {
        value: "",
        workflow_flowpointCurrentName: this.workflow_flowpointCurrentName,
        workflow_runId: this.workflow_runId,
        workflow_flowpointCurrentId: this.workflow_flowpointCurrentId,
        cySysWorkflowRuntimeTablePrimaryValue: this.cySysWorkflowRuntimeTablePrimaryValue,
        workflow_id: this.workflow_id,
        cySysWorkflowRuntimeTable: this.sets.datas.nzDataSource
      }
    }
    console.log("pageBlockDatas", JSON.stringify(this.pageService.pageBlockDatas[this.blockid]))
    if (nzSelectInit === false) {
      console.log('不工作流getWorkSelected');

    }else{
      console.log('工作流getWorkSelected');
      this.getWorkSelected();
    }
  }
  changevalue(event) {
    this.pageService.pageBlockDatas[this.blockid]['workflow']['value'] = event;
  }
  getWorkSelected() {
    this.pageService.pageSpin[this.layoutid]['wait']++;
    this.sets.datas.nzData = [];
    console.log("getWorkSelected", this.workflow_flowpointCurrentId, typeof this.workflow_flowpointCurrentId);

    //如果是初始化场景，给下拉框赋值 初始化
    if (this.workflow_flowpointCurrentId == "") {
      console.log("getWorkSelected:初始化", this.workflow_flowpointCurrentId, typeof this.workflow_flowpointCurrentId);
      this.sets.datas.nzData.push(
        {
          label: this.sets.styles.nzDefaultText,
          value: ""
        }
      );
      if (this.sets.datas.nzData.length > 0) {
        this.pageService.pageBlockDatas[this.blockid]['workflow']['value'] = this.sets.datas.nzData[0].value;
      }
      this.pageService.pageSpin[this.layoutid]['wait']--;
    } else {
      console.log("getWorkSelected:查询");
      const body = {
        "csysWorkflowRunId": this.workflow_runId,
        "csysPotId": this.workflow_flowpointCurrentId,
        "csysPageId": this.sets['pageId'],
        "csysPotPublicList": this.sets.datas.nzWorkflow.nzCsysPotPublicId,
        "csysPotStyleList": this.sets.datas.nzWorkflow.csysPotStyleList,
      }
      if (typeof this.workflow_flowpointCurrentId != "undefined" && typeof this.workflow_runId != 'undefined') {
        console.log("调用接口:getTrsStatus" + JSON.stringify(body));
        this.http.postHttp("/workflow/getTrsStatus", body).subscribe(
          (data: any) => {
            console.log("data:" + JSON.stringify(data));

            if (data.data.length > 0) {
              data.data.forEach(element => {
                console.log("工作流数据便利", element.csysCodemasterDesc);
                this.sets.datas.nzData.push(
                  {
                    label: element.csysCodemasterDesc != "" && element.csysCodemasterDesc != null ? element.csysCodemasterDesc : element.csysPotTrsPointName,
                    value: element.csysPotTrsId
                  }
                )
              });
            } else {
              this.sets.datas.nzData.push(
                {
                  label: this.sets.styles.nzDefaultText,
                  value: ""
                }
              )
            }
            if (this.sets.datas.nzData.length > 0) {
              this.pageService.pageBlockDatas[this.blockid]['workflow']['value'] = this.sets.datas.nzData[0].value;
            }
            console.log("工作流:" + JSON.stringify(this.sets.datas.nzData));
            this.pageService.pageSpin[this.layoutid]['wait']--;
          },
          (err: any) => {

          });

      } else {
        this.sets.datas.nzData.push(
          {
            label: this.sets.styles.nzDefaultText,
            value: ""
          }
        )
        // this.pageService.pageSpin[this.layoutid]['wait']--;
      }

    }

  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }

  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(

        data => {
          switch (data['type']) {
            case 'workflowSearch':
              console.log("通知工作流-调用工作流成功")
              break;
            case 'changeFormValid':
              this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
              break;
            default:
              break;
          }
        }
      )
    }, 100);

  }
  Listening() {
    setTimeout(() => {
      console.log('工作流注册Listening', this.blockid)
      this.setService.initEvent(this.blockid);

      this.setService.events[this.blockid].subscribe(
        data => {
          console.log('工作流-Listening',data);
          switch (data['type']) {

            case 'workflowSearch':
              console.log("通知工作流-调用工作流成功")
              console.log("通知工作流-获取数据", data['datas'])
              console.log("通知工作流-当前配置信息", this.sets.datas)
              let tablePrimaryValue = "";
              for (const key in data['datas']) {
                if (data['datas'].hasOwnProperty(key)) {
                  if (key == this.sets.datas.nzDataSource) {
                    //匹配当前数据源
                    const element = data['datas'][key];
                    if (element.length > 0) {
                      let currentElement = element[0]
                      console.log("通知工作流-遍历数据源", currentElement)
                      console.log("通知工作流-配置主键", this.sets.datas.nzWorkflow.nzPrimaryValue.key)
                      tablePrimaryValue = currentElement[this.sets.datas.nzWorkflow.nzPrimaryValue.key];

                    }


                  }

                }
              }
              console.log("通知工作流-主键值", tablePrimaryValue);
              //查询当前记录工作流信息

              let workflowbody = {
                "csysWorkflowRunTable": this.sets.datas.nzDataSource,
                "csysWorkflowRunTableVal": tablePrimaryValue,
              }

              console.log("workflowlistCondition" + JSON.stringify(workflowbody))
              this.http.postHttp("/csysworkflowrun/listCondition", workflowbody).subscribe(
                (data2: any) => {
                  console.log("listCondition！！！" + JSON.stringify(data2.data))

                  //存在工作流信息
                  if (data2.data.list.length > 0) {
                    this.workflow_id = data2.data.list[0].csysWorkflowId;
                    this.workflow_flowpointCurrentName = data2.data.list[0].csysPotName;
                    this.workflow_flowpointCurrentId = data2.data.list[0].csysPotId;
                    this.workflow_runId = data2.data.list[0].csysWorkflowRunId;
                    this.cySysWorkflowRuntimeTablePrimaryValue = data2.data.list[0].csysWorkflowRunTableVal;


                    this.pageService.pageBlockDatas[this.blockid] = {
                      workflow: {
                        value: this.pageService.pageBlockDatas[this.blockid].workflow.value,
                        workflow_flowpointCurrentName: data2.data.list[0].csysPotName,
                        workflow_runId: data2.data.list[0].csysWorkflowRunId,
                        workflow_flowpointCurrentId: data2.data.list[0].csysPotId,
                        cySysWorkflowRuntimeTablePrimaryValue: data2.data.list[0].csysWorkflowRunTableVal,
                        workflow_id: data2.data.list[0].csysWorkflowId,
                        cySysWorkflowRuntimeTable: this.sets.datas.nzDataSource
                      }
                    }
                  } else {
                    if (this.static) {
                      //不存在工作流信息，待初始化，尝试从场景值中取值
                      console.log("不存在工作流信息，待初始化，尝试从场景值中取值");
                      //获取场景值


                      this.queryParams = this.pageService.getQueryParams(this.activatedRoute, this.path);
                      this.workflow_id = this.queryParams['workflow_id'];
                      this.workflow_flowpointCurrentName = this.queryParams['workflow_flowpointCurrentName'];
                      this.workflow_flowpointCurrentId = this.queryParams['workflow_flowpointCurrentId'];
                      this.workflow_runId = this.queryParams['workflow_runId'];
                      this.cySysWorkflowRuntimeTablePrimaryValue = this.queryParams[this.sets.datas.nzWorkflow.nzPrimaryValue.key];



                    }



                  }



                  this.getWorkflowValue(true);
                });

              break;
            case 'linkagevalue':
              if (this.sets.datas.nzLinkageData.nzDynamicSql.length > 5) {
                this.linkageValue(data.datas.value, '')
              } else {
                this.cySysWorkflowRuntimeTablePrimaryValue = data.datas.value;
                this.pageService.pageBlockDatas[this.blockid]['workflow']['cySysWorkflowRuntimeTablePrimaryValue'] = data.datas.value;
              }

              break;

            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }
  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  linkageValue(value, type) {

    this.linkValue['linkage' + type] = value;
    let sql = this.sets.datas.nzLinkageData.nzDynamicSql;

    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);

    let body = {
      // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
      "dynamicSql": this.jwtService.replaceUser(sql),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("body:" + JSON.stringify(body));
    if (sql.indexOf("@linkage") == -1) {
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:" + JSON.stringify(data));
          if (data.data.list.length > 0) {
            this.cySysWorkflowRuntimeTablePrimaryValue = data.data.list[0]['VALUE'];
            this.pageService.pageBlockDatas[this.blockid]['workflow']['cySysWorkflowRuntimeTablePrimaryValue'] = data.data.list[0]['VALUE'];
          }
        })
    }

  }

}


